import { render, staticRenderFns } from "./RemainComparer.vue?vue&type=template&id=684f6db6"
import script from "./RemainComparer.vue?vue&type=script&lang=js"
export * from "./RemainComparer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports